var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('dashboard', {
    attrs: {
      "dashboardId": _vm.routeDashboardId
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };